import { createAction, props } from '@ngrx/store';
import { withNameSpace } from './message-conversation.actions';
import { MessageData } from '../models/message-data.model';

export const loadMessages = createAction(
  withNameSpace('Load messages'),
  props<{ conversationId: string, messageIds: string[] }>()
);

export const bulkLoadMessages = createAction(
  withNameSpace('Bulk load messages'),
  props<{ conversationId: string, messageIds: string[], retryCount: number }>()
);

export const messagesLoaded = createAction(
  withNameSpace('Messages loaded'),
  props<{ conversationId: string, messages: MessageData[] }>()
);

export const messagesLoadFailed = createAction(
  withNameSpace('Messages load failed'),
  props<{ conversationId: string, messageIds: string[], retryCount: number }>()
);

export const sendMessage = createAction(
  withNameSpace('Send message'),
  props<{ conversationId: string, textBody: string }>()
);

export const sendMessageSuccess = createAction(
  withNameSpace('Send message success'),
  props<{ conversationId: string, message: MessageData }>()
);

export const sendMessageFailed = createAction(
  withNameSpace('Send message failed'),
  props<{ conversationId: string, error?: any }>()
);

export const sendTypingIndicator = createAction(
  withNameSpace('Send typing indicator'),
  props<{ conversationId: string }>()
);

export const sendTypingIndicatorSuccess = createAction(
  withNameSpace('Send typing indicator success'),
  props<{ conversationId: string }>()
);

export const sendTypingIndicatorFailed = createAction(
  withNameSpace('Send typing indicator failed'),
  props<{ conversationId: string, error?: any }>()
);
